import React from 'react';
import './DataQcUnavailable.css';

const DataQcUnavailable: React.FC = () => {
  return (
    <div className="data-qc-unavailable-container">
      <div className="data-qc-unavailable-content">
        <div className="data-qc-unavailable-text">
          <p>Data quality check is not available yet</p>
        </div>
        <div className="data-qc-unavailable-image">
          <img src="/images/data-qc-unavailable.png" alt="Data QC unavailable" className="unavailable-image" />
        </div>
      </div>
    </div>
  );
};

export default DataQcUnavailable;
